module.exports = __webpack_public_path__ + "img/copy.ebe24281.svg";